<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M6,1C6,0.45,6.44,0,7,0C7.55,0,8,0.46,8,1L8,11C8,11.55,7.56,12,7,12C6.45,12,6,11.55,6,11L6,7L2,7L2,11C2,11.55,1.56,12,1,12C0.45,12,0,11.55,0,11L0,1C0,0.45,0.44,0,1,0C1.55,0,2,0.45,2,1L2,5L6,5L6,1ZM13.81,8.61C13.94,8.44,14.02,8.23,14.06,8L15,8L15,16L13.74,16L13.74,10.35L12,10.35L12,9.32C12.25,9.32,12.48,9.29,12.71,9.25C12.94,9.2,13.15,9.13,13.33,9.02C13.52,8.91,13.68,8.78,13.81,8.61Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'HeaderOne',
} as DefineComponent
</script>
